
import DocumentDetail from '@/components/DocumentDetail.vue';
import ActionsNotes from '@/components/_ActionsNotes/index.vue';
import JsonEditor from '@/components/JsonEditor/index.vue';
import { GET_INVOICE } from '@/gql';
import { mapGetters } from 'vuex';
import pdf from 'vue-pdf';
import { attachmentDownload } from '@/api/attachment';
import { isUriAttachment, S3_Attachment } from '@/schema/attachment';
import Logging from '@/logging';
import ViewsInvoices_userInterfaceDetails from './user-interface-details.graphql';
import CustomFieldsList from '@/components/_CustomFields/CustomFieldsList.vue';
import AttachmentsDialog from '@/components/_dialogs/AttachmentsDialog.vue';
import { invoiceUploadAttachment, invoiceDeleteAttachment } from '@/api/invoice';
import i18n from '@/i18n';
import { Risolto_Document_Attachment_Type_Enum } from '@/generated/graphql';
import Vue from 'vue';

export default Vue.extend({
	apollo: {
		userInterfaceDetails: {
			query: ViewsInvoices_userInterfaceDetails,
			variables() {
				return {
					participant: this.selectedParticipantStore
				};
			},
			update: data => data.userInterfaceDetails[0],
			skip() {
				return !this.currentInvoice;
			}
		}
	},
	components: {
		ActionsNotes,
		CustomFieldsList,
		DocumentDetail,
		JsonEditor,
		pdf,
		AttachmentsDialog
	},
	data() {
		return {
			invoiceFiles: [],
			currentInvoice: undefined,
			queryVars: {},
			queryVarsNotes: {
				limit: 3,
				offset: 0,
				invoice: this.$route.params.reference
			},
			queryVarsLatestActions: {
				limit: 3,
				offset: 0,
				invoice: this.$route.params.reference,
				status: ['DONE', 'CANCELED']
			},
			currentNotes: undefined,
			totalNotes: undefined,
			totalLatestActions: undefined,
			latestActions: undefined,
			latestAction: undefined,
			showCustomFields: false,
			attachmentsDialogVisible: false
		};
	},
	computed: {
		...mapGetters(['env', 'selectedParticipantStore']),
		showLoadMoreNotes() {
			if (this.totalNotes >= this.queryVarsNotes.limit) {
				return true;
			} else {
				return false;
			}
		},
		showLoadMoreLatestActions() {
			if (this.totalLatestActions >= this.queryVarsLatestActions.limit) {
				return true;
			} else {
				return false;
			}
		}
	},
	watch: {
		selectedParticipantStore() {
			this.queryVarsNotes.participant = this.selectedParticipantStore;
			this.queryVarsLatestActions.participant = this.selectedParticipantStore;
		},
		currentInvoice() {
			this.$store.dispatch('risolto/setSelectedInvoices', [this.currentInvoice]);
			for (const file of this.currentInvoice.file_references) {
				this.invoiceFiles.push(file);
			}
		}
	},
	created() {
		this.$store.commit('risolto/SET_NEW_NOTE_TYPE', 'single-invoice');

		if (this.selectedParticipantStore) {
			this.queryVarsLatestActions.participant = this.selectedParticipantStore;
		}

		this.queryVars = {
			invoice: this.$route.params.reference
		};

		this.$apollo
			.query({
				query: GET_INVOICE,
				variables: this.queryVars
			})
			.then(result => {
				Logging.log('result get invoice created', result);
				this.currentInvoice = result.data.invoice[0];
			})
			.catch(e => {
				Logging.log('e: ', e);
			});
	},
	methods: {
		handleAttachments() {
			this.attachmentsDialogVisible = true;
		},
		async handleAttachmentUpload(attachment: S3_Attachment) {
			try {
				await invoiceUploadAttachment(
					this.selectedParticipantStore,
					this.currentInvoice.legal_entity,
					this.currentInvoice.recipient,
					this.currentInvoice.reference,
					Risolto_Document_Attachment_Type_Enum.Pdf,
					attachment.name,
					attachment
				);

				this.currentInvoice.attachments = [...this.currentInvoice.attachments, attachment];
			} catch (e) {
				this.$notify({
					title: i18n.t('invoice-disputes.error') as string,
					message: i18n.t('invoice-disputes.attachment-can-not-be-uploaded') as string,
					type: 'error'
				});
				return;
			}
		},
		async handleAttachmentRemove(attachment: S3_Attachment) {
			try {
				await invoiceDeleteAttachment(attachment.key);
				this.currentInvoice.attachments = this.currentInvoice.attachments.filter((item) => item.key !== attachment.key);
			} catch (e) {
				this.$notify({
					title: i18n.t('invoice-disputes.error') as string,
					message: i18n.t('invoice-disputes.attachment-can-not-be-removed') as string,
					type: 'error'
				});
				return;
			}
		},
		async onDownload(val) {
			attachmentDownload(this.selectedParticipantStore, val);
		},
		isUriAttachment(val) {
			return isUriAttachment(val);
		}
	}
});
